<template>
  <v-layout align-start justify-center>
    <v-flex xs12 sm10 md10>
      <v-toolbar color="white">
        <v-toolbar-title>Members</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        item-key="name"
        select-all
        hide-actions
        class="elevation-1"
        ref="sortableTable"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th class="hidden-xs-only">
              <v-btn
                flat
                icon
                @click="isSorting = !isSorting"
              >
                <v-icon color="blue darken-2" v-if="isSorting">close</v-icon>
                <v-icon color="blue darken-2" v-else>sort</v-icon>
              </v-btn>
            </th>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.native="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="header.hidden"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <tr class="sortableRow" :key="itemKey(props.item)"> <!-- NOTE:  You'll need a unique ID, that is specific to the given item, for the key.   Not providing a unique key that's bound to the item object will break drag and drop sorting.  The itemKey method will return a uid for a given object using WeakMap.  You could just use a property in the object with a unique value, like "props.item.name" in this case, but often getting a unique value from the object's properties can be difficult, like when adding new rows, or when the unique field is open to editing, etc. -->
            <td class="hidden-xs-only px-1" style="width: 0.1%">
              <v-btn v-show="isSorting" style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
            </td>
            <td>
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td>{{ props.item.name }}</td>
            <td class="hidden-xs-only">{{ props.item.calories }}</td>
            <td class="hidden-xs-only">{{ props.item.fat }}</td>
            <td class="hidden-sm-and-down">{{ props.item.carbs }}</td>
            <td class="hidden-sm-and-down">{{ props.item.protein }}</td>
            <td class="hidden-sm-and-down">{{ props.item.sodium }}</td>
            <td class="hidden-sm-and-down">{{ props.item.calcium }}</td>
            <td class="hidden-sm-and-down">{{ props.item.iron }}</td>
          </tr>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  components: {
    Sortable
  },
  data () {
    return {
      search: '',
      selected: [],
      isSorting: false,
      itemKeys: new WeakMap(),
      currentItemKey: 0,
      headers: [
        {
          text: 'Dessert (100g serving)',
          align: 'left',
          value: 'name'
        },
        { text: 'Calories', value: 'calories', hidden: 'hidden-xs-only' },
        { text: 'Fat (g)', value: 'fat', hidden: 'hidden-xs-only' },
        { text: 'Carbs (g)', value: 'carbs', hidden: 'hidden-sm-and-down' },
        { text: 'Protein (g)', value: 'protein', hidden: 'hidden-sm-and-down' },
        { text: 'Sodium (mg)', value: 'sodium', hidden: 'hidden-sm-and-down' },
        { text: 'Calcium (%)', value: 'calcium', hidden: 'hidden-sm-and-down' },
        { text: 'Iron (%)', value: 'iron', hidden: 'hidden-sm-and-down' }
      ],
      items: [
        {
          value: false,
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          sodium: 87,
          calcium: '14%',
          iron: '1%'
        },
        {
          value: false,
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          sodium: 129,
          calcium: '8%',
          iron: '1%'
        },
        {
          value: false,
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          sodium: 337,
          calcium: '6%',
          iron: '7%'
        },
        {
          value: false,
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          sodium: 413,
          calcium: '3%',
          iron: '8%'
        },
        {
          value: false,
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          sodium: 327,
          calcium: '7%',
          iron: '16%'
        },
        {
          value: false,
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          sodium: 50,
          calcium: '0%',
          iron: '0%'
        },
        {
          value: false,
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          sodium: 38,
          calcium: '0%',
          iron: '2%'
        },
        {
          value: false,
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          sodium: 562,
          calcium: '0%',
          iron: '45%'
        },
        {
          value: false,
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          sodium: 326,
          calcium: '2%',
          iron: '22%'
        },
        {
          value: false,
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          sodium: 54,
          calcium: '12%',
          iron: '6%'
        }
      ]
    }
  },
  mounted () {
    /* eslint-disable no-new */
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder
      }
    )
  },
  methods: {
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },
    dragReorder ({oldIndex, newIndex}) {
      const movedItem = this.items.splice(oldIndex, 1)[0]
      this.items.splice(newIndex, 0, movedItem)
    },
    itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
      return this.itemKeys.get(item)
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Table2.vue